export default __webpack_public_path__ + "static/media/3.aac1cede.jpg";